import React, { memo } from 'react'

import PageHeader from './components/PageHeader'
import PageFilter from './components/PageFilter'
import EmptyFiltersValues from './components/EmptyFiltersValues'
import PageBody from './components/PageBody'
import Spinner from 'components/CommonUI/Spinner/Spinner'
import { getIsFetchingAdminProfileSelector } from 'redux/reducers/devices'
import { useShallowEqualSelector } from 'custom-hooks'

const DeviceConnection = ({ isAllFiltersSelected }) => {
  const isFetchingAdminProfileSelector = useShallowEqualSelector(
    getIsFetchingAdminProfileSelector
  )

  return (
    <div className="page_container device_connection_page_container">
      {isFetchingAdminProfileSelector && <Spinner />}
      <PageHeader />
      <PageFilter />
      {isAllFiltersSelected ? <PageBody /> : <EmptyFiltersValues />}
    </div>
  )
}

export default memo(DeviceConnection)
